import { Navigate, Outlet } from "react-router-dom";
import { hasPermission } from "utils/HasPermission";


interface Props {
  permission?: any;
}

const ProtectedRoute = ({ permission }: Props) => {
  if (!permission || hasPermission(permission)) {
    return <Outlet />;
  }
  return <Navigate to="/access-denied" replace />;
};

export default ProtectedRoute;
